<section>
  <header [ngClass]="data.type">
    <h2>CaseInfoSearch</h2>
  </header>
  <main>{{ data.message }}</main>
  <footer>
    <div class="row">
      <div class="col-3">
        <eap-button variant="primary" width="100%" (clicked)="onClose()" [label]="'OK'"></eap-button>
      </div>
    </div>
  </footer>
</section>
